<template>
	
	<div class="burger-overlay">
		<div class="close"></div>
		
		<div class="burger-logo">
      <a href="https://www.the-iacr.net" title="IACR" id="website_mobile_logo_iarc">
         <img class="header-menu-logo" src="https://gco.iarc.who.int/media/iacr/images/IACR_logo_mobile.png" alt="logo-white">
      </a>
      <a :href="website_url" id="website_mobile_logo">
				<img class="website_mobile_logo" :src="website_mobile_logo" :title="website_title" />
			</a>
    </div>
		
		<ul id="menu-general-menu-1" class="general-menu">
			<li :class="['menu-item','menu-item-mobile','menu-item-type-post_type','menu-item-object-cards_page']" 
				v-for="menu in menus">
				<router-link :to="{ name : menu.route , params : { lang : 'en' } }" v-on:click="clickMenuItemMobile()">
          {{ menu.label }}
        </router-link>
				<!--<a href="#" class="sign"></a>-->
			</li>
		</ul>
		
		<div class="burger-bottom tablet">
			<ul class="copyright-burger">
			</ul>
		</div>
	</div>

</template>

<script>

export default {
  name: 'NavMobile',
  components: {

  },
  props : {
    menus : { type : Array , default : [] } , 
    website_logo :  { type : String , default : "" } ,
    website_mobile_logo : { type : String } , 
    website_url :  { type : String , default : "" } ,  
    website_title :  { type : String , default : "" }     
  },
  data () {
    return {
    	route : '' , 
    	mobile_logo : 'https://gco.iarc.who.int/img/GCO-logo-White-60.png'
    }
  },
  mounted(){
  	$('div.burger').click(function() {
      // console.log("open burger") ; 
      $('body').addClass('burger-body');
    });
    $('.burger-overlay .close').click(function() {
    	// console.log("close burger") ; 
      $('body').removeClass('burger-body');
    });
  },
  methods:{
    clickMenuItemMobile:function(){
      console.info("clickMenuItemMobile")
      $('body').removeClass('burger-body');
    }
  }
}

</script>

<style lang="scss">

.burger-overlay{
	padding-top: 20px;
	.burger-logo{
		margin: 10px 0 ; 
	}
  a#website_mobile_logo{
    display: none;
  }
}

</style>